/**
 * @version
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 *
 * @author Jenny Lam <jlam@buildcentrix.com>
 *
 * @copyright (c) 2023 Build Centrix
 */

'use strict';
import * as angular from 'angular';
import * as ngCookies from 'angular-cookies';
import * as ngResource from 'angular-resource';
import * as ngRoute from 'angular-route';
import * as ngSanitize from 'angular-sanitize';
import * as ngTouch from 'angular-touch';
import 'angular-ui-router';

// This module only initializes the routing with html5Mode
export const BlankApp = angular
  .module('blankApp', [ngCookies, ngResource, ngRoute, ngSanitize, ngTouch])
  .config(function ($locationProvider) {
    $locationProvider.html5Mode(true);
  });

// EOF
